import type { FC } from 'react';
import React from 'react';
import { Box } from '@withjoy/joykit';
import type { DuoPhotoRendererProps, PhotoDuoArrangement } from './PhotoDuo.types';
import { getAspectRatio, getScreenPartition } from './PhotoDuo.utils';

const getContainerHeight = (arrangement: PhotoDuoArrangement, index: number) => {
  if (arrangement === 'left') {
    return '100%';
  }
  return index === 0 ? 'auto' : '98%';
};

export const DuoPhotoRenderer: FC<DuoPhotoRendererProps> = props => {
  const { photo, arrangement, index, containerDimensions, firstItemHeight, photoRenderer: PhotoRenderer } = props;
  const aspectRatio = getAspectRatio(arrangement, index);
  const screenPartition = getScreenPartition(arrangement, index);
  const width = containerDimensions.width * screenPartition;

  return (
    <Box
      width="100%"
      height={getContainerHeight(arrangement, index)}
      aspectRatio={aspectRatio}
    >
      <PhotoRenderer
        photoUrl={photo.photoUrl}
        cropInfo={photo.cropInfo ? { ...photo.cropInfo, unit: '%' } : null}
        width={width}
        height={firstItemHeight}
        containerType="fixed-aspect"
      />
    </Box>
  );
};
